import PropTypes from 'prop-types';
// material
import CheckCircleRoundedIcon from '@mui/icons-material/CheckCircleRounded';
import QueryBuilderIcon from '@mui/icons-material/QueryBuilder';
import GppBadIcon from '@mui/icons-material/GppBad';

PaymentIcon.propTypes = {
  status: PropTypes.string
};

export default function PaymentIcon({ status }) {
  switch (status) {
    case 'AUTHORIZED':
      return <CheckCircleRoundedIcon color="success" fontSize="large" />;
    case 'AWAITING':
      return <QueryBuilderIcon color="warning" fontSize="large" />;
    default:
      return <GppBadIcon color="error" fontSize="large" />;
  }
}
